const FbTracker = require("./FbTracker");
const GtmTracker = require("./GtmTracker");
const WisePopTracker = require("./WisepopsTracker");
const MixPanelTracker = require("./MixPanelTracker");
const HubspotTracker = require("./HubspotTracker");
const KameleoonTracker = require("./KameleoonTracker");

let initialized = false

const runTracker = (trackerName, fn) => {
  try {
    fn();
  } catch (err) {
    window.clientLogger?.error("MainTracker tracker failed", {
      code: "main_tracker_tracker_failed",
      tracker: trackerName,
      error: err,
    });
  }
};

export const MainTracker = {
    init: () =>{
      if (initialized){
        window.clientLogger.warn('Main Tracker init more than once')
      }
      else{
        GtmTracker.init()
        MixPanelTracker.init()
        initialized = true
      }
    },
    identify: (uuid,email) => {
        runTracker("MixPanelTracker.identify", () => MixPanelTracker.identify(uuid));
        runTracker("HubspotTracker.identify", () => HubspotTracker.identify(email));
    },
    alias: (id) => {
        MixPanelTracker.alias(id);
    },
    superProperties: (props) => {
      try{
        MixPanelTracker.superProperties(props);
      }
      catch(err){
        window.clientLogger.error('MainTracker error setting superProerties',err)
      }
    },
    unregisterSuperProperties: (names) => {
      try{
        MixPanelTracker.unregisterSuperProperties(names);
      }
      catch(err){
        window.clientLogger.error('MainTracker error unregistering superProperties',err)
      }
    },
    track: (eventType,eventName, data) => {
      runTracker("MixPanelTracker.track", () => MixPanelTracker.track(eventType,eventName, data));
      runTracker("GtmTracker.track", () => GtmTracker.track(eventType,eventName,data?.tagManager));
      runTracker("FbTracker.track", () => FbTracker.track(eventType,eventName,data?.facebook));
      runTracker("HubspotTracker.track", () => HubspotTracker.track(eventType,eventName,data));
      runTracker("WisePopTracker.track", () => WisePopTracker.track(eventType,eventName,data));
      runTracker("Kameleoon.track", () => window.kameleoonQueue?.push(["Events.trigger", eventName]));
      runTracker("KameleoonTracker.trackFunnelEvent", () => KameleoonTracker.trackFunnelEvent(eventName, data));
    },
    people: {
      set: (props) => {
        MixPanelTracker.setPeople(props);
      },
    },

}




